import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { CompositeSessionInfoSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../../codegen/Localize';
import { DatabaseForUngrouping,ungroupDatabasesAction } from '../../actions/databases/UngroupDatabasesAction';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const UngroupDatabasesEntityAction: IEntityAction<DatabaseForUngrouping, {}> = {
  name: EntityActionNames.UngroupDatabases,
  translateName: Messages.ungroupDatabases_action,
  isVisible: (items: DatabaseForUngrouping[], state) => {
    const featureEnabled =
        CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state) &&
        FeatureFlags.mergeDedupeDatabasesEnabled &&
        selectCatalogingOnSiteEnabled(state);
    const hasUngroupedItems = items.some(item => !item.isGrouped);
    const hasGroupedItems = items.some(item => item.isGrouped);
    return featureEnabled && hasGroupedItems && !hasUngroupedItems;
  },
  isClickable: (_, items) => items.length === 1,
  createReduxAction: (items: DatabaseForUngrouping[]) => {
    return ungroupDatabasesAction(items[0]);
  }
};
